import React from 'react';
import NoteIcon from '../../../../icons/NoteIcon';

import { getElementStyles } from '../../elementStyles';
import { toggleNoteVisibility } from '../../../../../actions/reduxActions/canvasNotes';
import { connect } from 'react-redux';
 
/**
 * 
 * @param {Object} mapElement The map element metadata
 * @param {Object} styles Defined element styling
 * @param {Function} toggleVisibility Toggles showing/hiding note content
 * 
 * @description The draggable element that appears on the Flow canvas to represent a note 
 */
const NoteElement = ({ mapElement = {}, styles, toggleNoteVisibility: toggleVisibility, isHovered, isSelected, isDragging }) => {
    const { id } = mapElement;

    const elementStyles = styles || getElementStyles(mapElement.elementType);

    return (
        <g 
            data-testid={`element-${id}`}
            onDoubleClick={() => toggleVisibility(id)}
        >
            {(isHovered || isSelected) && !isDragging && <rect {...styles.outBorder} className="map-element-hover-out" />}
            <rect {...elementStyles.border} className="map-element-border" />
            <rect {...elementStyles.fill} id={`element-inner-${id}`} className="map-element-fill" />
            {
                <foreignObject {...elementStyles.content}>
                    <span className="map-element-content note-element-content">
                        <NoteIcon />
                    </span>
                </foreignObject>
            }
        </g>
    );
};

export default connect(
    null, { toggleNoteVisibility },
)(NoteElement);
